import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Assignment, Done } from '@material-ui/icons';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';

import { WithApp } from 'contexts/appContext';
import ModalFull from 'components/Tvendo/Common/ModalFull';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 130 },
  { Header: 'Código', accessor: 'CardCode' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ProviderSelectModal(props) {
  const classes = useStyles();

  const { open, setOpen, providers, onSelect } = props;

  return (
    <ModalFull title="Seleccionar Proveedor" open={open} setOpen={setOpen}>
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Elija un proveedor</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            defaultWidth={800}
            exportExcel={false}
            columns={columns}
            data={providers.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    <Button
                      justIcon
                      size="sm"
                      round
                      onClick={() => {
                        onSelect({ cardCode: item.CardCode, cardName: item.CardName });
                        setOpen(false);
                      }}
                      color="success"
                    >
                      <Done />
                    </Button>
                  </div>
                ),
                CardCode: item.CardCode,
                CardName: item.CardName,
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </ModalFull>
  );
});
